import { HelpOutline } from "@mui/icons-material"
import { Tooltip, Typography, Box } from "@mui/material"

export const CoverageRequirementTooltip = () => {
    return (
        <Tooltip 
            title={
                <Box sx={{ p: 0.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        Coverage Requirement
                    </Typography>
                    <Typography variant="body2">
                        The minimum percentage of available funds that must be available in order to enable a particular module for a user. This ensures there are sufficient funds to support the intended use of that module.
                    </Typography>
                </Box>
            } 
            sx={{ marginRight: "auto", marginLeft: "4px" }}
        >
            <HelpOutline />
        </Tooltip>
    )
}